import React, { useEffect, useState } from 'react';
import api from '../../services/api';

function Stars({ n }) {
  return (
    <span className="text-amber-500 tracking-tight" title={`${n}/5`}>
      {'★'.repeat(n)}{'☆'.repeat(5 - n)}
    </span>
  );
}

export default function AdminRatings() {
  const [data, setData] = useState({ count: 0, average: 0, ratings: [] });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/ratings/admin')
      .then((r) => setData(r.data || { count: 0, average: 0, ratings: [] }))
      .catch((e) => setError(e.response?.data?.message || 'Could not load ratings'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-sm text-slate-400">Loading ratings…</p>;

  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight">App ratings</h1>
      <p className="mt-1 text-sm text-slate-500">Ratings submitted by users (1–5 stars).</p>

      {error && (
        <div className="mt-4 rounded-xl border border-rose-100 bg-rose-50 px-3.5 py-2.5 text-sm text-rose-700">{error}</div>
      )}

      <div className="mt-5 grid grid-cols-2 gap-3 max-w-md">
        <div className="rounded-2xl border border-slate-200 bg-white p-4">
          <p className="text-xs text-slate-500 uppercase tracking-wide">Average</p>
          <p className="text-2xl font-bold text-slate-900 mt-1">
            {data.average || 0}
            <span className="text-sm font-normal text-slate-400"> / 5</span>
          </p>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-4">
          <p className="text-xs text-slate-500 uppercase tracking-wide">Total</p>
          <p className="text-2xl font-bold text-slate-900 mt-1">{data.count || 0}</p>
        </div>
      </div>

      <div className="mt-6 bg-white rounded-xl border border-slate-100 shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
            <tr>
              <th className="text-left p-3">User</th>
              <th className="text-left p-3">Rating</th>
              <th className="text-left p-3">Comment</th>
              <th className="text-left p-3">Updated</th>
            </tr>
          </thead>
          <tbody>
            {(data.ratings || []).length === 0 && (
              <tr>
                <td colSpan={4} className="p-6 text-center text-slate-400">No ratings yet</td>
              </tr>
            )}
            {(data.ratings || []).map((r) => (
              <tr key={r.id} className="border-t border-slate-50 align-top">
                <td className="p-3">
                  <div className="font-medium">{r.fullName || '—'}</div>
                  <div className="text-xs text-slate-400">{r.email}</div>
                  {r.phoneNumber && <div className="text-xs text-slate-400">{r.phoneNumber}</div>}
                </td>
                <td className="p-3 whitespace-nowrap">
                  <Stars n={r.stars || 0} />
                  <div className="text-xs text-slate-400">{r.stars}/5</div>
                </td>
                <td className="p-3 text-slate-600 max-w-xs">{r.comment || '—'}</td>
                <td className="p-3 text-xs text-slate-500 whitespace-nowrap">
                  {r.updatedAt ? new Date(r.updatedAt).toLocaleString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
